import gsap from "gsap";

export default class Single {
    constructor() {
        this.traumaSwitch = false;
        this.init();
    }

    init() {
        this.pageIn();
        this.setTeamnav();
        this.protectimg();
        this.eventBind();
    }

    pageIn() {
        const tl = new gsap.timeline();

        //カーテンがあるとき
        if ($(".single__curtain").length > 0) {
            tl.fromTo(".single__curtain", { duration: 0.6, width: "100%", left: "0" }, { width: "0%", ease: "Circ.easeInOut" }, 0.4);
        }
        tl.fromTo(".single__inner_bg", { duration: 0.6, width: "0%", height: "0%" }, { width: "100%", height: "100%", ease: "Circ.easeInOut" }, 0.4);
        tl.fromTo(".profile", { duration: 0.5, opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 0.8);
        tl.fromTo(".profile__visual div:not(.-notl)", { duration: 0.5, opacity: 0, y: 50 }, { stagger: 0.2, opacity: 1, y: 0 }, 0.8);
        tl.fromTo(".detail", { duration: 0.5, opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 1.2);
    }

    setTeamnav() {
        
        //ナビのアクティブ化
        const bodyclass = document.body.getAttribute('class');
        [...document.querySelectorAll('.teamnav__item')].forEach($item=>{
            if(bodyclass.indexOf($item.getAttribute("data-target")) > 0) {
                $item.classList.add("-active");
            }
        });

        // チームナビのアクティブ化
        let key = document.body.getAttribute('data-team');
        if(key === '1nm8') key = `t_${key}`;
        document.querySelector(`.-item_${key}`).classList.add('-current');

        // キャラサムネのアクティブ化
        [...document.querySelectorAll('.profile__members__item')].forEach($item=>{
            const className = `-${$item.getAttribute('data-key')}`;
            if(document.body.classList.contains(className)){
                $item.classList.add('-current');
            }
        });
    }

    eventBind() {
        document.querySelector(".js-trauma_button").addEventListener("click", () => {
            this.traumaSwitch = !this.traumaSwitch;
            this.transitionText();
            document.body.classList.toggle("-trauma");
        });

        const $btn = document.querySelector(".js-switch_button");
        if ($btn) {
            $btn.addEventListener("click", () => {
                document.body.classList.toggle("-switch");
            });
        }
    }

    transitionText() {
        const $text = document.querySelectorAll(".js-shuffletxt");
        const strarray = ["縺", "＞", "縺", "∴", "�", "撰", "ｼ", "托", "抵", "ゑ", "繧", "繝", "卍", "繹", "◆", "◇", "■", "□", ""];

        $text.forEach((el) => {
            const mode = this.traumaSwitch ? "data-trauma" : "data-normal";

            const end = el.getAttribute(mode).split("");
            const $cont = el.querySelector(".js-shuffletxt__cont");

            const count = end.length;
            let start = 0;
            let transtxt = [];

            for (let i = 0; i < count; i++) {
                transtxt.push(strarray[Math.floor(Math.random() * strarray.length)]);
            }

            $cont.innerHTML = transtxt.join("");

            const transition = () => {
                transtxt[start] = end[start];

                $cont.innerHTML = transtxt.join("");

                start++;

                if (start <= count) {
                    setTimeout(transition, 25);
                }
            };

            setTimeout(transition, 500);
        });
    }

    protectimg() {
        function imageGuard(selector) {
            var guard_selector = document.querySelectorAll(selector);

            var guard_style = {
                "pointer-events": "none",
                "-webkit-touch-callout": "none",
                "-moz-touch-callout": "none",
                "touch-callout": "none",
                "-webkit-user-select": "none",
                "-moz-user-select": "none",
                "user-select": "none",
            };

            Object.keys(guard_style).forEach(function (v, i, a) {
                for (var n = 0; n < guard_selector.length; n++) {
                    guard_selector[n].style[v] = guard_style[v];
                }
            });
        }

        document.addEventListener("DOMContentLoaded", function () {
            imageGuard("img");
        });

        document.addEventListener(
            "contextmenu",
            function (e) {
                e.preventDefault();
            },
            false
        );
    }
}
